export var getLineItemIds = function (lineItems) {
    return lineItems
        .filter(function (item) { return !(item === null || item === void 0 ? void 0 : item.isAssembly) && !(item === null || item === void 0 ? void 0 : item.parentLine) && !(item === null || item === void 0 ? void 0 : item.lineParentId); })
        .map(function (item) { return Number(item === null || item === void 0 ? void 0 : item.lineId); })
        .filter(function (lineId) { return !Number.isNaN(lineId); });
};
